import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { hasValue } from 'utils/NumberUtil'
import SuperMultiAutocomplete from '../SuperMultiAutocomplete'
import SectorAction from 'referencial/components/sector/actions/SectorAction'
import useUpdateEffect from 'utils/customHook/useUpdateEffect'

const AssociatedSectorSelect = ({
    col,
    stationTypeReturn,
    value,
    onChange = () => { },
    disabled = false,
}) => {
    const dispatch = useDispatch()

    const {
        sectors,
        qualitometersAssociations,
    } = useSelector(store => ({
        sectors: store.SectorReducer.sectors,
        qualitometersAssociations: store.SectorReducer.qualitometersAssociations,
    }), shallowEqual)

    const [sector, setSector] = useState(value)
    const [associatedStation, setAssociatedStation] = useState([])

    useEffect(() => {
        dispatch(SectorAction.fetchSectors())
    }, [])

    useUpdateEffect(() => {
        setSector(value)
    }, [value])

    useEffect(() => {
        if (sector) {
            dispatch(SectorAction.fetchQualitometersAssociations(sector))
        } else {
            setAssociatedStation([])
        }
    }, [dispatch, sector, stationTypeReturn])

    useEffect(() => {
        setAssociatedStation(qualitometersAssociations)
    }, [qualitometersAssociations])

    useEffect(() => {
        onChange(associatedStation, sector)
    }, [associatedStation])

    const fullLabel = useMemo(() => {
        if (!hasValue(sector) || !associatedStation) {
            return i18n.sector
        }
        if (associatedStation.length <= 1) {
            return `${i18n.sector} (${associatedStation.length} ${i18n.station})`
        }
        return `${i18n.sector} (${associatedStation.length} ${i18n.stations})`
    }, [associatedStation?.length, sector])

    return (
        <SuperMultiAutocomplete
            col={col}
            options={sectors}
            values={sector}
            label={fullLabel}
            onChange={setSector}
            disabled={disabled}
            keyValue='id'
        />
    )
}

AssociatedSectorSelect.propTypes = {
    col: PropTypes.number,
    stationTypeReturn: PropTypes.number,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func, // (list, id) => {}
}

export default AssociatedSectorSelect